<script setup lang="ts">
import BaseLayout from "./base.vue";
</script>

<template>
  <base-layout>
    <template #header>
      <layout-page-header />
    </template>

    <slot />

    <template #footer>
      <version-footer />
    </template>
  </base-layout>
</template>
